export const formatStringForUrl = (key: string | null | undefined): string => {
  return key ? key.toLowerCase().replace(/\s+/g, '_') : '';
};
